import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'div',
    'toastCloseWrapper',
    'feedback-toast'
)`
    ${propStyles};
    top: 0;
`;

StyledComponent.defaultProps = {
    position: 'absolute',
    right: '0',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastCloseWrapper.tsx